import { ChangeDetectionStrategy, Component, computed, effect, input, signal, ViewEncapsulation } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ControlErrorMessage } from '../../../../../contract/control-error-message.contract';
import { MessagesComponent } from '../../../../messages/messages/messages.component';

@Component({
  selector: 'osp-error',
  standalone: true,
  imports: [MessagesComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ErrorComponent {
  $errors = input<ValidationErrors | null | undefined>(undefined, { alias: 'errors' });
  $messages = input<ControlErrorMessage | undefined>(undefined, { alias: 'messages' });

  constructor() {
    effect(() => this.setControlErrors(this.$errors()!), { allowSignalWrites: true });
  }

  private $controlErrors = signal<ValidationErrors | null>(null);
  public $errorMessagesList = computed(() => {
    const errors = this.$messages() ?? {};
    return Object.keys(errors).map((key) => ({ errorType: key, message: errors[key] })) ?? [];
  });

  protected $error = computed(() =>
    this.$controlErrors() && this.$errorMessagesList().length > 0
      ? this.$errorMessagesList().find(({ errorType }) => (this.$controlErrors() ?? {})[errorType])?.message
      : null,
  );

  public setControlErrors(errors: ValidationErrors | null): void {
    this.$controlErrors.set(errors);
  }
}
